import Vue from "vue"
import Vuex from "vuex"
import users from "./users"
import sidebar from "./sidebar"
import statuses from "./statuses"
import taskcontrol from "./taskcontrol"
import VuexPersistence from "vuex-persist"
import apollo from "@/apolloClient"

const usersPlugin = async store => {
  // Called when store is initialized
  const { data } = await apollo.query({
    query: require("@/graphql/Account/GetUsers.gql")
  })
  store.commit("setUsers", { users: data.users })
}
const statusesPlugin = async store => {
  // Called when store is initialized
  const { data } = await apollo.query({
    query: require("@/graphql/Status/GetStatuses.gql")
  })
  store.commit("setStatuses", { statuses: data.statuses })
}
const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})
Vue.use(Vuex)

export default new Vuex.Store({
  modules: { users, sidebar, taskcontrol, statuses },
  plugins: [vuexLocal.plugin, statusesPlugin, usersPlugin]
})
